import { createStore } from "vuex";
import axios from "axios";

import SalesRep from "./modules/SalesRep";
import Material from "./modules/Material";
import AvailableInventory from "./modules/AvailableInventory";
import Quote from "./modules/Quote";
import BuyGroupDate from "./modules/BuyGroupDate";
import LocationPricelist from "./modules/LocationPricelist";
import FlagSetting from "./modules/FlagSetting";
import OrderLimit from "./modules/OrderLimit";
import Setting from "./modules/Setting";
import users from './modules/users'
import pricelists from "./modules/pricelists";
import OrderMinimumQuantitySettings from "./modules/OrderMinimumQuantitySettings";
import ProcessingFee from "./modules/ProcessingFee";

// export default createStore({
export const store = createStore({
    state() {
        return {
            user: {},
            locations: [],
            allLocations: [],
            currentLocation: {},
            subUsersByUserId: [],
            subUsers: [],
            allUsers: [],
            pricelistsTable: [],
            dealerPriceLists: [],
            pricelists: [],
            allCategories: [],
            filteredPricelists: [],
            allOrders: [],
            allOrdersAll: [],
            filteredOrders: [],
            orderId: 0,
            orderInfo: {},
            allInvoices: [],
            invoicesByOrderNumber: [],
            filteredInvoices: [],
            invoiceId: 0,
            invoiceInfo: {},
            userInfo: {},
            allUsersByLocation: [],
            locationInfo: {},
            totalOrders: [],
            orders: JSON.parse(localStorage.getItem("orders")),
            orderLinesReport: [],
            syncedOrders: [],
            products: JSON.parse(localStorage.getItem("products")),
            allstates: [],
            selectedStatePriceList: null,
            isD2DUser: false,
            settings: [],
            isSpeq: false,
            speqProgramCounts: [],
            notes: [],
        };
    },
    getters: {
        user: (state) => state.user,
        locations: (state) => state.locations,
        allLocations: (state) => state.allLocations,
        currentLocation: (state) => state.currentLocation,
        subUsersByUserId: (state) => state.subUsersByUserId,
        subUsers: (state) => state.subUsers,
        allUsers: (state) => state.allUsers,
        pricelistsTable: (state) => state.pricelistsTable,
        dealerPriceLists: (state) => state.dealerPriceLists,
        pricelists: (state) => state.pricelists,
        allCategories: (state) => state.allCategories,
        filteredPricelists: (state) => state.filteredPricelists,
        allOrders: (state) => state.allOrders,
        filteredOrders: (state) => state.filteredOrders,
        orderId: (state) => state.orderId,
        orderInfo: (state) => state.orderInfo,
        allInvoices: (state) => state.allInvoices,
        invoicesByOrderNumber: (state) => state.invoicesByOrderNumber,
        filteredInvoices: (state) => state.filteredInvoices,
        invoiceId: (state) => state.invoiceId,
        invoiceInfo: (state) => state.invoiceInfo,
        userInfo: (state) => state.userInfo,
        allUsersByLocation: (state) => state.allUsersByLocation,
        locationInfo: (state) => state.locationInfo,
        totalOrders: (state) => state.totalOrders,
        orders: (state) => state.orders,
        orderLinesReport: (state) => state.orderLinesReport,
        syncedOrders: (state) => state.syncedOrders,
        selectedStatePriceList: (state) => state.selectedStatePriceList,
        isD2DUser: (state) => state.isD2DUser,
        settings: (state) => state.settings,
        isSpeq: (state) => state.isSpeq,
        speqProgramCounts: (state) => state.speqProgramCounts,
        notes: (state) => state.notes,
    },
    actions: {
        async registerDealer({ commit }, request) {
            //fetch list of locations
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/register-dealer", request)
                    .then((data) => {
                        window.emitter.emit("changeLoaderStatus", false);
                        window.location.href = "/message";
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async activateUser({ commit, dispatch }, id) {
            //add location
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.post("/api/activate-user/" + id).then((data) => {
                    dispatch("getAllUsers");
                    dispatch('getUserById', id);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async sendAccountApprovedEmail({ commit, dispatch }, id) {
            //send account approved email
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/send-account-approved-email/" + id)
                    .then((data) => {
                        dispatch("getAllUsers");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updateUserOnlineOrder({ commit, dispatch }, id) {
            //update online order
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-user-online-order/" + id)
                    .then((data) => {
                        dispatch("getAllUsers");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updateUserDemoAccount({ commit, dispatch }, id) {
            //update online order
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-user-demo-account/" + id)
                    .then((data) => {
                        dispatch("getAllUsers");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updateUserQuoteAccess({ commit, dispatch }, id) {
            //update quote access
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-user-quote-access/" + id)
                    .then((data) => {
                        dispatch("getAllUsers");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updateUserAccess({ commit, dispatch }, id) {
            //update user access
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-user-access/" + id)
                    .then((data) => {
                        dispatch("getAllUsers");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updateSpeqInviteAccess({ commit, dispatch }, id) {
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-speq-invite-access/" + id)
                    .then((data) => {
                        dispatch("getAllUsers");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                console.log(error);
            }
        },
        async getLocations({ commit }, request) {
            //fetch list of locations
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.post("/api/get-locations", request).then((data) => {
                    commit("setLocations", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getLocationById({ commit, dispatch }, id) {
            //fetch location by id
            try {
                window.emitter.emit("changeLoaderStatus", true);
                const data = await axios
                    .get("/api/get-location-by-id/" + id)
                    .then((data) => {
                        commit("setLocationInfo", data.data.result);
                        dispatch("getAllUsersByLocation", { location_id: id });
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async getAllLocations({ commit }, request) {
            //fetch list of all locations
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-all-locations", request)
                    .then((data) => {
                        commit("setAllLocations", data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getLocationByInput({ commit }, request) {
            //fetch list of locations by input
            try {
                // window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-location-by-input", request)
                    .then((data) => {
                        commit("setAllLocations", data.data.result);
                        // window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async addLocation({ commit, dispatch }, request) {
            //add location
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/store-location", request)
                    .then((data) => {
                        dispatch("getLocations", { user_id: request.user_id });
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updateLocation({ commit, dispatch }, request) {
            //add location
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-location", request)
                    .then((data) => {
                        dispatch("getLocations", { user_id: request.user_id });
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async deleteLocationFromUser({ commit, dispatch }, request) {
            //add location
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/delete-location-from-user", request)
                    .then((data) => {
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async denyUser({ commit, dispatch }, request) {
            //deny an account
            try {
                window.emitter.emit("changeLoaderStatus", true);
                const response = await axios
                    .post("/api/deny-user/"+request.user_id, request)
                    .then((data) => {
                        window.emitter.emit("changeLoaderStatus", false);
                        return data;
                    });
                return response;
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async getSubUsersByUserId({ commit }, request) {
            //fetch list of sub users
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-sub-users-by-user-id", request)
                    .then((data) => {
                        commit("setSubUsersByUserId", data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async getSubUsers({ commit }) {
            //fetch list of sub users
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-sub-users").then((data) => {
                    commit("setSubUsers", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async addSubUser({ commit, dispatch }, request) {
            //add sub user
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/store-sub-user", request)
                    .then((data) => {
                        dispatch("getSubUsers");
                        dispatch("getAllUsers");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updateSubUser({ commit, dispatch }, request) {
            //add sub user
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-sub-user", request)
                    .then((data) => {
                        dispatch("getSubUsers");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updatePassword({ commit, dispatch }, request) {
            //update password
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-password", request)
                    .then((data) => {
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async deleteSubUser({ commit, dispatch }, request) {
            //delete sub user
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/delete-sub-user", request)
                    .then((data) => {
                        dispatch("getSubUsers");
                        dispatch("getAllUsers");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async getAllUsers({ commit }, request) {
            //fetch list of all users
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-all-users", request).then((data) => {
                    commit("setAllUsers", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getUserById({ commit, dispatch }, id) {
            //fetch user by id
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-user-by-id/" + id).then((data) => {
                    commit("setUserInfo", data.data.result);
                    dispatch("getLocations", { user_id: id });
                    dispatch("getSubUsersByUserId", { user_id: id });

                    if( data.data.result?.notes ){
                        commit('setUserNotes', data.data.result.notes);
                    }
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async getPricelistsTable({ commit }) {
            //fetch list of all pricelist products
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-pricelists-table").then((data) => {
                    commit("setPricelistsTable", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                alert(error.message)
                console.log(error);
            }
        },
        async getDealerPriceLists({ commit, state }, request) {
            //fetch list of all pricelist products
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-pricelists-table/dealer", request)
                    .then((data) => {
                        commit("setDealerPriceLists", data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getAllPricelists({ commit }, request) {
            //fetch list of all pricelist products            
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-all-pricelists", request)
                    .then((data) => {
                        commit("setPricelists", data.data.result);
                        commit("setFilteredPricelists", data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getAllCategories({ commit }, request) {
            //fetch list of all categories
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-all-categories", request)
                    .then((data) => {
                        commit("setAllCategories", data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async searchPricelist({ commit, state }, dataFilter) {
            //search pricelist
            try {
                // const data = await axios.get('/api/get-all-pricelists');
                // let pricelists = data.data.result;
                let pricelists = state.pricelists;
                let pricelists2 = [];
                var val = dataFilter.category
                    ? dataFilter.searchCategory
                    : dataFilter.searchTerm;

                if (val === "") {
                    return [];
                }

                let matches = 0;

                pricelists2 = pricelists.filter((prod) => {
                    if (!dataFilter.category) {
                        if (
                            prod.product_name
                                .toLowerCase()
                                .includes(val.toLowerCase()) ||
                            prod.sku.toLowerCase().includes(val.toLowerCase())
                        ) {
                            return prod;
                        }
                    } else {
                        if (val == "all") {
                            return prod;
                        } else if (val == "SUPPRESSOR") {
                            if (
                                (prod.category1
                                    .toLowerCase()
                                    .includes(val.toLowerCase()) ||
                                    prod.category2
                                        .toLowerCase()
                                        .includes(val.toLowerCase())) &&
                                // || prod.category3.toLowerCase().includes(val.toLowerCase())
                                // || prod.category4.toLowerCase().includes(val.toLowerCase())
                                prod.sku.substring(0, 2) == "SU"
                            ) {
                                return prod;
                            }
                        } else if (val == "ACCESSORY") {
                            if (
                                (prod.category1
                                    .toLowerCase()
                                    .includes(val.toLowerCase()) ||
                                    prod.category2
                                        .toLowerCase()
                                        .includes(val.toLowerCase())) &&
                                // || prod.category3.toLowerCase().includes(val.toLowerCase())
                                // || prod.category4.toLowerCase().includes(val.toLowerCase())
                                prod.sku.substring(0, 2) == "AC"
                            ) {
                                return prod;
                            }
                        } else if (
                            prod.category1
                                .toLowerCase()
                                .includes(val.toLowerCase()) ||
                            prod.category2
                                .toLowerCase()
                                .includes(val.toLowerCase())
                            // || prod.category3.toLowerCase().includes(val.toLowerCase())
                            // || prod.category4.toLowerCase().includes(val.toLowerCase())
                        ) {
                            return prod;
                        } else {
                        }
                    }
                });

                // commit('setPricelists', pricelists2);
                commit("setFilteredPricelists", pricelists2);
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async getOrderByOrderNumber({ commit, dispatch }, request) {
            //fetch order by order number
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-order-by-order-number", request)
                    .then((data) => {
                        commit("setOrderInfo", data.data.result);
                        dispatch("getInvoicesByOrderNumber", {
                            order_number: data.data.result.order_number,
                        });
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getAllOrders({ commit }, request) {
            //fetch list of all orders
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-all-orders", request)
                    .then((data) => {
                        commit("setAllOrders", data.data.result);
                        // commit('setFilteredOrders', data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async getAllOrdersAll({ commit }, request) {
            //fetch list of all orders
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-all-orders", request)
                    .then((data) => {
                        commit("setAllOrdersAll", data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async submitOrder({ commit, dispatch }, request) {
            //add order
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.post("/api/submit-order", request).then((data) => {
                    commit("setOrderId", data.data.order_id);
                    dispatch("getAllOrders", {
                        location_id: request.location_id,
                    });
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updateOrder({ commit, dispatch }, request) {
            //update order
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.post("/api/update-order", request).then((data) => {
                    // commit('setOrderId', data.data.order_id);
                    commit("setOrderInfo", data.data.order);
                    dispatch("getAllOrders", {
                        location_id: request.location_id,
                    });
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async deleteOrder({ commit, dispatch }, request) {
            //delete order
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.post("/api/delete-order", request).then((data) => {
                    dispatch("getAllOrders", {
                        location_id: request.location_id,
                    });
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updateOrderStatus({ commit, dispatch }, request) {
            //update order status
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-order-status", request)
                    .then((data) => {
                        dispatch("getAllOrders", {
                            location_id: request.location_id,
                        });
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async searchOrders({ commit, state }, dataFilter) {
            //search orders
            try {
                let allOrders = state.allOrders;
                let allOrders2 = [];
                var val = dataFilter.searchTerm;

                if (val === "") {
                    return [];
                }

                allOrders2 = allOrders.filter((order) => {
                    if (
                        order.po_number
                            .toLowerCase()
                            .includes(val.toLowerCase()) ||
                        order.order_number
                            .toLowerCase()
                            .includes(val.toLowerCase()) ||
                        order.payment_terms
                            .toLowerCase()
                            .includes(val.toLowerCase()) ||
                        order.notes.toLowerCase().includes(val.toLowerCase())
                    ) {
                        return order;
                    }
                });

                commit("setFilteredOrders", allOrders2);
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async getAllInvoices({ commit }, request) {
            //fetch list of all invoices
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-all-invoices", request)
                    .then((data) => {
                        commit("setAllInvoices", data.data.result);
                        // commit('setFilteredInvoices', data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getInvoiceById({ commit }, id) {
            //fetch invoice by id
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-invoice-by-id/" + id).then((data) => {
                    if (data.data.result) {
                        commit("setInvoiceInfo", data.data.result);
                    } else {
                        window.location.href = "/";
                    }
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async getInvoicesByOrderNumber({ commit }, request) {
            //fetch invoices by order number
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-invoices-by-order-number", request)
                    .then((data) => {
                        commit("setInvoicesByOrderNumber", data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async searchInvoices({ commit, state }, dataFilter) {
            //search invoices
            try {
                let allInvoices = state.allInvoices;
                let allInvoices2 = [];
                var val = dataFilter.searchTerm;

                if (val === "") {
                    return [];
                }

                allInvoices2 = allInvoices.filter((invoice) => {
                    if (
                        (invoice.invoice_number !== null &&
                            invoice.invoice_number
                                .toLowerCase()
                                .includes(val.toLowerCase())) ||
                        (invoice.invoice_origin !== null &&
                            invoice.invoice_origin
                                .toLowerCase()
                                .includes(val.toLowerCase())) ||
                        (invoice.payment_terms !== null &&
                            invoice.payment_terms
                                .toLowerCase()
                                .includes(val.toLowerCase())) ||
                        (invoice.reference !== null &&
                            invoice.reference
                                .toLowerCase()
                                .includes(val.toLowerCase()))
                    ) {
                        return invoice;
                    }
                });

                commit("setFilteredInvoices", allInvoices2);
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async sendEmail({ commit, dispatch }, request) {
            //sendEmail
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.post("/api/send-email", request).then((data) => {
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getAllUsersByLocation({ commit }, request) {
            //fetch list of all users
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-all-users-by-location", request)
                    .then((data) => {
                        commit("setAllUsersByLocation", data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async getTotalOrders({ commit }, request) {
            //fetch total orders this month and year
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/get-total-orders", request)
                    .then((data) => {
                        commit("setTotalOrders", data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async addOrder({ commit, state }, order) {
            let tempOrders = state.orders;
            let matchedOrderIndex = -1;

            matchedOrderIndex = tempOrders.findIndex(
                (item) => item.id === order.id
            );

            if (matchedOrderIndex !== -1) {
                tempOrders[matchedOrderIndex]["quantity"] += order.quantity;
            } else {
                tempOrders.push(order);
            }

            localStorage.setItem("orders", JSON.stringify(tempOrders));
            commit("setOrders", tempOrders);
        },
        async updateUserAddress({ commit, dispatch }, request) {
            //update user address
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-user-address", request)
                    .then((data) => {
                        window.emitter.emit("alertSuccess", {
                            message: "User Address is updated successfully!",
                        });
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async orderLinesReport({ commit }, request) {
            //fetch invoices by order number
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/order-lines-report", request)
                    .then((data) => {
                        commit("setOrderLinesReport", data.data.result);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async exportToExcel({ commit }, request) {
            //fetch invoices by order number
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.post("/api/export-report", request).then((data) => {
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getAllSyncedOrders({ commit }, { page = 1, search = '' } = {}) {
            //fetch list of all orders
            try {
                window.emitter.emit("changeLoaderStatus", true);

                const response = await axios.get("/api/get-all-synced-orders", {
                    params: {
                        page: page,
                        search: search,
                    },
                });

                commit("setSyncedOrders", response.data);

                return response.data;
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            } finally {
                window.emitter.emit("changeLoaderStatus", false);
            }
        },
        async getStates({ commit }) {
            //fetch list of all orders
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-states").then((data) => {
                    commit("setStates", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async getIsD2DUser({ commit }) {
            try {
                await axios.get("/api/check-d2d-user").then((data) => {
                    commit("setIsD2DUser", true);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async getSettings({ commit }) {
            //fetch list of all orders
            try {
                await axios.get("/api/settings").then((data) => {
                    commit("setSettings", data.data);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async sendSpeqInvite({ commit, dispatch }, id) {
            //add location
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/send-speq-invite/" + id).then((data) => {
                    dispatch("getLocationById", id);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async acceptSpeqInvite({ commit, dispatch }, request) {
            //accept speq invite
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.post("/api/accept-speq-invite", request).then((data) => {
                    dispatch("getLocationById", id);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async adminAcceptSpeqInvite({ commit, dispatch }, request) {
            //admin accept speq invite
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.post("/api/admin-accept-speq-invite", request).then((data) => {
                    dispatch("getLocationById", request.id);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async markAsSold({ commit, dispatch }, id) {
            //mark as sold order
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/mark-as-sold/" + id).then((data) => {
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async flagUser({ commit, dispatch }, request) {
            //update online order
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/flag-user", request)
                    .then((data) => {
                        dispatch("getUserById", request.userid);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async flagAllUsers({ commit, dispatch }, request) {
            //update online order
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/flag-all-users", request)
                    .then((data) => {
                        dispatch("getAllUsersByLocation", { location_id: request.location_id });
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async getSpeqProgramCounts({ commit }) {
            //fetch list of all orders
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-speq-program-counts").then((data) => {
                    commit("setSpeqProgramCounts", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async updateUserD2C({ commit, dispatch }, id) {
            //update online order
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-user-d2c/" + id)
                    .then((data) => {
                        dispatch("getAllUsers");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async addUserNote({ commit, dispatch }, request) {
            
            try {
                const response = await axios
                    .post("/api/add-user-note/"+request.userId, request)
                    .then((data) => {
                        return data;
                    });

                return response;
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setLocations(state, locations) {
            state.locations = locations;
        },
        setAllLocations(state, allLocations) {
            state.allLocations = allLocations;
        },
        setCurrentLocation(state, currentLocation) {
            state.currentLocation = currentLocation;
        },
        setSubUsers(state, subUsers) {
            state.subUsers = subUsers;
        },
        setSubUsersByUserId(state, subUsersByUserId) {
            state.subUsersByUserId = subUsersByUserId;
        },
        setAllUsers(state, allUsers) {
            state.allUsers = allUsers;
        },
        setPricelistsTable(state, pricelistsTable) {
            state.pricelistsTable = pricelistsTable;
        },
        setDealerPriceLists(state, dealerPriceLists) {
            state.dealerPriceLists = dealerPriceLists;
        },
        setPricelists(state, pricelists) {
            state.pricelists = pricelists;
        },
        setAllCategories(state, allCategories) {
            state.allCategories = allCategories;
        },
        setFilteredPricelists(state, pricelists) {
            state.filteredPricelists = pricelists;
        },
        setAllOrders(state, allOrders) {
            state.allOrders = allOrders;
        },
        setAllOrdersAll(state, allOrdersAll) {
            state.allOrdersAll = allOrdersAll;
        },
        setFilteredOrders(state, filteredOrders) {
            state.filteredOrders = filteredOrders;
        },
        setOrderId(state, orderId) {
            state.orderId = orderId;
        },
        setOrderInfo(state, orderInfo) {
            state.orderInfo = orderInfo;
        },
        setAllInvoices(state, allInvoices) {
            state.allInvoices = allInvoices;
        },
        setInvoicesByOrderNumber(state, invoicesByOrderNumber) {
            state.invoicesByOrderNumber = invoicesByOrderNumber;
        },
        setFilteredInvoices(state, filteredInvoices) {
            state.filteredInvoices = filteredInvoices;
        },
        setInvoiceId(state, invoiceId) {
            state.invoiceId = invoiceId;
        },
        setInvoiceInfo(state, invoiceInfo) {
            state.invoiceInfo = invoiceInfo;
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setUserNotes(state, userNotes) {
            state.notes = userNotes;
        },
        setAllUsersByLocation(state, allUsersByLocation) {
            state.allUsersByLocation = allUsersByLocation;
        },
        setLocationInfo(state, locationInfo) {
            state.locationInfo = locationInfo;
        },
        setTotalOrders(state, totalOrders) {
            state.totalOrders = totalOrders;
        },
        setOrders(state, orders) {
            state.orders = orders;
        },
        setOrderLinesReport(state, orderLinesReport) {
            state.orderLinesReport = orderLinesReport;
        },
        setSyncedOrders(state, syncedOrders) {
            state.syncedOrders = syncedOrders;
        },
        setProducts(state, products) {
            state.products = products;
        },
        setSelectedStatePriceList(state, selectedStatePriceList) {
            state.selectedStatePriceList = selectedStatePriceList;
        },
        setStates(state, allstates) {
            state.allstates = allstates;
        },
        setIsD2DUser(state, isD2DUser) {
            state.isD2DUser = isD2DUser;
        },
        setSettings(state, settings) {
            state.settings = settings;
        },
        setIsSpeq(state, isSpeq) {
            state.isSpeq = isSpeq;
        },
        setSpeqProgramCounts(state, speqProgramCounts) {
            state.speqProgramCounts = speqProgramCounts;
        },
    },
    modules: {
        salesRep: SalesRep,
        material: Material,
        availableInventory: AvailableInventory,
        quote: Quote,
        buyGroupDate: BuyGroupDate,
        locationPricelist: LocationPricelist,
        flagSetting: FlagSetting,
        orderLimit: OrderLimit,
        setting: Setting,
        users: users,
        pricelistsData: pricelists,
        orderSetting: OrderMinimumQuantitySettings,
        processingFee: ProcessingFee,
    },
});
